/**
 * 滚动到顶部
 * @param px 滚动到距离顶部的像素值，默认为370
 * @param mode 滚动模式，默认为"smooth
 */
export const scrollToTop = (
  px: number = 370,
  mode: "auto" | "smooth" | "instant" = "smooth",
) => {
  window.scrollTo({
    top: px,
    behavior: mode,
  });
};
